import styles from './MobileMenu.module.scss';

const SeparatorRedesign = () => (
  <div className={styles['separator-redesign']} />
);

export default SeparatorRedesign;
